/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"
import { Link } from "gatsby"

export default () => (
  <div>
    <h1>Links at bottom of page</h1>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <p>
      <strong>Pellentesque habitant morbi tristique</strong> senectus et netus
      et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat
      vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet
      quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris
      placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
      pharetra. Vestibulum erat wisi, condimentum sed,
      {` `}
      <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit
      eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus
      enim ac dui. <a href="#">Donec non enim</a> in turpis pulvinar facilisis.
      Ut felis.
    </p>
    <div>
      <Link to="/">Go to home</Link>
    </div>
    <div>
      <Link to="/cat/">Go to cat</Link>
    </div>
    <div>
      <Link to="/dog/">Go to dog</Link>
    </div>
  </div>
)
